export enum PunchoutTracingConstants {
  capability = 'orders',
  transferButtonClickContext = 'Punchout Transfer Button Click',
  event = 'Order Transmit',
}
